import {
  IonBadge,
  IonButton,
  IonChip,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import {cameraOutline, logoGooglePlaystore, notificationsOutline} from "ionicons/icons";
import {HomeBackButton} from "app/employee/menu/HomeBackButton";
import {MenuButton} from "app/employee/menu/MenuButton";
import {useTranslation} from "react-i18next";
import {useBootstrapEmployeeStore} from "app/employee/state/bootstrapEmployee/mutations";
import {chunk} from "app/utils/stdlib";
import {styled} from "styled-components";
import {FlexColumn} from "app/employee/flexUtils";
import {ListPadding} from "app/employee/incdoc/ListPadding";

const Title = styled.div`
  font-size: 1.4rem;
  line-height: 1.5rem;
  text-align: center;
`;

const SubTitle = styled.div`
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 1rem;
`;

const StrongIonChip = styled(IonChip)`
  font-weight: bold;
  font-size: 1.1rem;
`;

export const AndroidApp = () => {
  const {t} = useTranslation();
  const playStoreUrl = "https://play.google.com/store/apps/details?id=bg.fsacademy";
  const accessCode = useBootstrapEmployeeStore((state) => {
    const result = state.bootstrapResult.value;
    return result?.__typename === "BootstrapEmployee" ? chunk(result.employee.accessCode, 3).join("-") : undefined;
  });

  return (
    <>
      <IonHeader>
        <IonToolbar>
          <HomeBackButton />
          <IonTitle>{t("android-app.title")}</IonTitle>
          <MenuButton />
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonList lines="full">
          <IonItem>
            <IonLabel className="ion-text-wrap">
              <FlexColumn>
                <Title>{t("android-app.heading")}</Title>
                <SubTitle>{t("android-app.how-to-start")}</SubTitle>
              </FlexColumn>
            </IonLabel>
          </IonItem>

          <IonItem>
            <StrongIonChip color="dark" slot="start">
              1
            </StrongIonChip>
            <IonLabel>
              <FlexColumn>
                <strong>{t("android-app.step1")}</strong>
                <div>
                  <IonButton fill="solid" href={playStoreUrl} rel="noopener noreferrer" size="default" target="_blank">
                    <IonIcon icon={logoGooglePlaystore} slot="start" />
                    {t("android-app.download-button")}
                  </IonButton>
                </div>
              </FlexColumn>
            </IonLabel>
          </IonItem>

          <IonItem>
            <StrongIonChip color="dark" slot="start">
              2
            </StrongIonChip>
            <IonLabel>
              <strong>{t("android-app.step2")}</strong>
            </IonLabel>
          </IonItem>

          <IonItem>
            <StrongIonChip color="dark" slot="start">
              3
            </StrongIonChip>
            <IonLabel>
              <FlexColumn>
                <strong>{t("android-app.step3")}</strong>
                <div>
                  <IonBadge color="dark" style={{fontSize: "1.8rem", letterSpacing: "0.15em"}}>
                    {accessCode}
                  </IonBadge>
                </div>
                <p>{t("android-app.footer-note")}</p>
              </FlexColumn>
            </IonLabel>
          </IonItem>
        </IonList>

        <IonList lines="full">
          <IonItem>
            <IonLabel className="ion-text-wrap">
              <SubTitle>{t("android-app.intro")}</SubTitle>
            </IonLabel>
          </IonItem>

          <IonItem>
            <IonIcon color="primary" icon={cameraOutline} size="large" slot="start" />
            <IonLabel className="ion-text-wrap">
              <strong>{t("android-app.scanner-title")}</strong>
              <p>{t("android-app.scanner-desc")}</p>
            </IonLabel>
          </IonItem>

          <IonItem>
            <IonIcon color="primary" icon={notificationsOutline} size="large" slot="start" />
            <IonLabel className="ion-text-wrap">
              <strong>{t("android-app.notifications-title")}</strong>
              <p>{t("android-app.notifications-desc")}</p>
            </IonLabel>
          </IonItem>
        </IonList>
        <ListPadding />
      </IonContent>
    </>
  );
};
